module.exports = __webpack_public_path__ + "static/media/camille.a7df98ff.jpg";